import script from "./psiShopPanCunStastic.vue?vue&type=script&setup=true&lang=js"
export * from "./psiShopPanCunStastic.vue?vue&type=script&setup=true&lang=js"

import "./psiShopPanCunStastic.vue?vue&type=style&index=0&id=0c6cbf6e&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c6cbf6e"]])

export default __exports__